import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Card, Row, Col, Form, InputNumber,
	Button, Select, message, Spin, Tag, Typography,
} from 'antd';
import {
	SaveOutlined, CloseCircleOutlined, SettingOutlined,
	ArrowLeftOutlined, EditOutlined, PlusCircleOutlined,
	RiseOutlined, BankOutlined, CalendarOutlined,
} from '@ant-design/icons';

import Config from '../../Config';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig, extractResult } from '../../store/actions';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const BULAN_NAMA = [
	'', 'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
	'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember',
];

const configClass = {
	title: 'Form Target Pendapatan',
	apiUrl: {
		preview: 'master/api/target-pendapatan/',
		kabupaten: 'master/api/kabupaten/',
	},
	pageUrl: { data: '/admin/pengaturan/target-pendapatan/' },
};

const config = new Config();

const FIELD_STYLE = {
	borderRadius: 8,
	height: 40,
};

const rp = v => 'Rp ' + (v || 0).toLocaleString('id-ID');
const rpFmt = val => val ? 'Rp ' + String(val).replace(/\B(?=(\d{3})+(?!\d))/g, '.') : 'Rp 0';
const rpParse = val => val ? Number(val.replace(/Rp\s?|[.]/g, '').replace(',', '')) : 0;

class FormTargetPendapatan extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errTitle: '', errMsg: '',
			loadingButton: false,
			loadingKabupaten: false,
			listKabupaten: [],
			aksi: 'tambah', method: 'post', idLama: '',
			sukses: false,
			// nilai live form untuk preview kalkulasi
			targetPkb: 0, targetBbnkb: 0, targetTotal: 0,
			persenValues: { 1:0,2:0,3:0,4:0,5:0,6:0,7:0,8:0,9:0,10:0,11:0,12:0 },
			isMobile: window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	async componentDidMount() {
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
		await this.loadKabupaten();
		if (this.props.match.params.id !== undefined) {
			this.preview(this.props.match.params.id);
		}
	}

	async loadKabupaten() {
		this.setState({ loadingKabupaten: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.kabupaten + '?limit=100')
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					const list = Array.isArray(data) ? data : (data.results || []);
					this.setState({ listKabupaten: list });
				}
				this.setState({ loadingKabupaten: false });
			})
			.catch(() => this.setState({ loadingKabupaten: false }));
	}

	async preview(id) {
		message.loading({ content: 'Menampilkan data sebelumnya...', duration: 0, key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + id)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					const persenValues = {};
					const fields = {};
					for (let m = 1; m <= 12; m++) {
						persenValues[m] = data[`persen_${m}`] || 0;
						fields[`persen_${m}`] = data[`persen_${m}`] || 0;
					}
					this.formRef.current.setFieldsValue({
						tahun: data.tahun,
						kabupaten: data.kabupaten || undefined,
						target_pkb: data.target_pkb,
						target_bbnkb: data.target_bbnkb,
						target_total: data.target_total,
						...fields,
					});
					this.setState({
						aksi: 'edit', method: 'put', idLama: id + '/',
						targetPkb: data.target_pkb,
						targetBbnkb: data.target_bbnkb,
						targetTotal: data.target_total,
						persenValues,
					});
					message.destroy();
				} else {
					this.setState({ errTitle: 'error preview', errMsg: data });
					message.error({ content: 'error preview data', duration: 2, key: 'toast' });
				}
			})
			.catch(() => message.error({ content: 'gagal request data', duration: 2, key: 'toast' }));
	}

	handleSubmit = (values) => {
		const datas = {
			tahun: values.tahun,
			kabupaten: values.kabupaten || null,
			target_pkb: values.target_pkb || 0,
			target_bbnkb: values.target_bbnkb || 0,
			target_total: values.target_total || 0,
		};
		for (let m = 1; m <= 12; m++) {
			datas[`persen_${m}`] = values[`persen_${m}`] || 0;
		}
		this.postData(datas);
	};

	async postData(datas) {
		message.loading({ content: 'Memproses...', key: 'toast' });
		this.setState({ loadingButton: true });
		this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview + this.state.idLama, datas, false, true)
			.then((action) => {
				this.setState({ loadingButton: false });
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					message.success({ content: 'berhasil menyimpan data', duration: 2, key: 'toast' });
					this.setState({ sukses: true });
				} else {
					const errTitle = 'gagal menyimpan data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'kesalahan pengiriman data', duration: 2, key: 'toast' });
			});
	}

	onNominalChange = () => {
		if (!this.formRef.current) return;
		const pkb   = this.formRef.current.getFieldValue('target_pkb')   || 0;
		const bbnkb = this.formRef.current.getFieldValue('target_bbnkb') || 0;
		this.formRef.current.setFieldsValue({ target_total: pkb + bbnkb });
		this.setState({ targetPkb: pkb, targetBbnkb: bbnkb, targetTotal: pkb + bbnkb });
	};

	onPersenChange = (m, val) => {
		const newPersen = { ...this.state.persenValues, [m]: val || 0 };
		this.setState({ persenValues: newPersen });
	};

	render() {
		if (this.state.sukses) return <Redirect to={configClass.pageUrl.data} />;

		const tahunNow = new Date().getFullYear();
		const tahunOptions = [];
		for (let y = tahunNow + 2; y >= tahunNow - 3; y--) {
			tahunOptions.push(<Select.Option key={y} value={y}>{y}</Select.Option>);
		}

		const { targetPkb, targetBbnkb, targetTotal, persenValues, isMobile, aksi, errMsg, errTitle, loadingButton } = this.state;
		const totalPersen = Object.values(persenValues).reduce((a, b) => a + (b || 0), 0);
		const persenOk = Math.abs(totalPersen - 100) < 0.01;
		const isEdit = aksi === 'edit';
		const pageTitle = isEdit ? 'Edit Target Pendapatan' : 'Tambah Target Pendapatan';

		const thStyle = {
			padding: '8px 10px', fontSize: 11, fontWeight: 700,
			background: '#fafafa', borderBottom: '1px solid #e8e8e8',
			textAlign: 'right', whiteSpace: 'nowrap',
		};
		const thLeft = { ...thStyle, textAlign: 'left' };
		const td = { padding: '6px 10px', fontSize: 12, textAlign: 'right', borderBottom: '1px solid #f5f5f5' };
		const tdLeft = { ...td, textAlign: 'left', fontWeight: 600 };

		return (
			<div>
				<Helmet>
					<title>{pageTitle + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.form-targetpendapatan-wrap .ant-form-item-label > label {
							font-weight: 600;
							color: #374151;
							font-size: 13px;
						}
						.form-targetpendapatan-wrap .ant-input,
						.form-targetpendapatan-wrap .ant-select-selector,
						.form-targetpendapatan-wrap .ant-input-number {
							border-radius: 8px !important;
						}
						.form-targetpendapatan-wrap .ant-input:focus,
						.form-targetpendapatan-wrap .ant-select-focused .ant-select-selector {
							border-color: #1e4d8a !important;
							box-shadow: 0 0 0 2px rgba(30,77,138,0.1) !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Form
					ref={this.formRef}
					layout="vertical"
					onFinish={this.handleSubmit}
					className="form-targetpendapatan-wrap"
					initialValues={{ tahun: tahunNow, target_pkb: 0, target_bbnkb: 0, target_total: 0,
						...Object.fromEntries(Array.from({length:12},(_,i)=>[`persen_${i+1}`,0])) }}
				>
					<Card
						style={{
							borderRadius: 14,
							boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
							overflow: 'hidden',
						}}
						bodyStyle={{ padding: 0 }}
					>
						{/* Header */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex',
							alignItems: 'center',
							gap: 16,
						}}>
							<div style={{
								width: 52,
								height: 52,
								borderRadius: 14,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								flexShrink: 0,
							}}>
								{isEdit
									? <EditOutlined style={{ color: '#fff', fontSize: 24 }} />
									: <PlusCircleOutlined style={{ color: '#fff', fontSize: 24 }} />
								}
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>
									{pageTitle}
								</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, marginTop: 3 }}>
									{isEdit ? 'Ubah target pendapatan PKB & BBNKB' : 'Isi formulir untuk menambah target pendapatan baru'}
								</div>
							</div>
							<Link to={configClass.pageUrl.data}>
								<Button
									icon={<ArrowLeftOutlined />}
									style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', borderRadius: 8, flexShrink: 0 }}
								>
									{!isMobile && 'Kembali'}
								</Button>
							</Link>
						</div>

						{/* Section header */}
						<div style={{
							padding: '14px 24px',
							background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
							borderBottom: '1.5px solid #d0dff5',
							display: 'flex',
							alignItems: 'center',
							gap: 10,
						}}>
							<RiseOutlined style={{ color: '#1e4d8a', fontSize: 16 }} />
							<Text strong style={{ fontSize: 14, color: '#0f2847' }}>
								Informasi Target
							</Text>
						</div>

						{/* Form fields */}
						<div style={{ padding: '24px 28px 8px' }}>
							<Row gutter={16}>
								<Col xs={24} sm={12} md={8}>
									<Form.Item
										label={<span><CalendarOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Tahun</span>}
										name="tahun"
										rules={[{required:true,message:'Tahun wajib diisi'}]}
									>
										<Select placeholder="Pilih tahun" style={{ width: '100%' }}>{tahunOptions}</Select>
									</Form.Item>
								</Col>
								<Col xs={24} sm={12} md={16}>
									<Form.Item
										label={<span><BankOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Kabupaten/Kota</span>}
										name="kabupaten"
									>
										{this.state.loadingKabupaten ? <Spin size="small" /> : (
											<Select placeholder="Semua Kabupaten (Bapenda)" allowClear showSearch
												filterOption={(input, opt) => (opt.children||'').toLowerCase().includes(input.toLowerCase())}>
												{this.state.listKabupaten.map(k => (
													<Select.Option key={k.id} value={k.id}>{k.name}</Select.Option>
												))}
											</Select>
										)}
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={16}>
								<Col xs={24} sm={8}>
									<Form.Item label="Target PKB Tahunan (Rp)" name="target_pkb" rules={[{required:true}]}>
										<InputNumber style={{width:'100%', ...FIELD_STYLE}} min={0} step={1000000}
											formatter={rpFmt} parser={rpParse} onChange={this.onNominalChange} />
									</Form.Item>
								</Col>
								<Col xs={24} sm={8}>
									<Form.Item label="Target BBNKB Tahunan (Rp)" name="target_bbnkb" rules={[{required:true}]}>
										<InputNumber style={{width:'100%', ...FIELD_STYLE}} min={0} step={1000000}
											formatter={rpFmt} parser={rpParse} onChange={this.onNominalChange} />
									</Form.Item>
								</Col>
								<Col xs={24} sm={8}>
									<Form.Item label="Target Total Tahunan (Rp)" name="target_total" rules={[{required:true}]}>
										<InputNumber style={{width:'100%', ...FIELD_STYLE}} min={0} step={1000000}
											formatter={rpFmt} parser={rpParse}
											onChange={v => this.setState({ targetTotal: v || 0 })} />
									</Form.Item>
								</Col>
							</Row>
						</div>

						{/* Section header: alokasi */}
						<div style={{
							padding: '14px 24px',
							background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
							borderBottom: '1.5px solid #d0dff5',
							borderTop: '1px solid #f0f0f0',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							gap: 10,
							flexWrap: 'wrap',
						}}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
								<CalendarOutlined style={{ color: '#1e4d8a', fontSize: 16 }} />
								<Text strong style={{ fontSize: 14, color: '#0f2847' }}>
									Alokasi Target per Bulan
								</Text>
							</div>
							{persenOk
								? <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' }}>Total: {totalPersen.toFixed(2)}% ✓</Tag>
								: <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322' }}>Total: {totalPersen.toFixed(2)}% (harus = 100%)</Tag>
							}
						</div>

						{/* Tabel alokasi per bulan */}
						<div style={{ padding: '20px 24px 8px' }}>
							<div style={{ overflowX: 'auto', borderRadius: 10, border: '1px solid #f0f0f0' }}>
								<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
									<thead>
										<tr>
											<th style={thLeft}>Bulan</th>
											<th style={thStyle}>% Alokasi</th>
											<th style={thStyle}>Target PKB</th>
											<th style={thStyle}>Target BBNKB</th>
											<th style={thStyle}>Target Total</th>
										</tr>
									</thead>
									<tbody>
										{Array.from({ length: 12 }, (_, i) => i + 1).map(m => {
											const p = persenValues[m] || 0;
											return (
												<tr key={m}>
													<td style={tdLeft}>{BULAN_NAMA[m]}</td>
													<td style={{ ...td, padding: '4px 8px' }}>
														<Form.Item name={`persen_${m}`} noStyle>
															<InputNumber
																min={0} max={100} step={0.5} precision={2}
																style={{ width: 80, borderRadius: 8 }}
																onChange={v => this.onPersenChange(m, v)}
															/>
														</Form.Item>
														<span style={{ marginLeft: 4, color: '#888' }}>%</span>
													</td>
													<td style={td}>{rp(Math.round(targetPkb   * p / 100))}</td>
													<td style={td}>{rp(Math.round(targetBbnkb * p / 100))}</td>
													<td style={{ ...td, fontWeight: 700, color: '#1e4d8a' }}>
														{rp(Math.round(targetTotal * p / 100))}
													</td>
												</tr>
											);
										})}
										<tr style={{ background: '#f0f7ff', fontWeight: 700 }}>
											<td style={tdLeft}>TOTAL</td>
											<td style={{ ...td, fontWeight: 700, color: persenOk ? '#52c41a' : '#f5222d' }}>
												{totalPersen.toFixed(2)}%
											</td>
											<td style={td}>{rp(targetPkb)}</td>
											<td style={td}>{rp(targetBbnkb)}</td>
											<td style={{ ...td, color: '#1e4d8a' }}>{rp(targetTotal)}</td>
										</tr>
									</tbody>
								</table>
							</div>
							{!persenOk && (
								<div style={{ color: '#f5222d', fontSize: 12, marginTop: 8, marginBottom: 8 }}>
									⚠ Total persentase harus = 100%. Sisa: {(100 - totalPersen).toFixed(2)}%
								</div>
							)}
						</div>

						{/* Footer tombol */}
						<div style={{
							padding: '16px 28px',
							display: 'flex',
							gap: 10,
							justifyContent: isMobile ? 'stretch' : 'flex-end',
							flexDirection: isMobile ? 'column' : 'row',
							background: '#fafafa',
							borderTop: '1px solid #f0f0f0',
							marginTop: 8,
						}}>
							<Link to={configClass.pageUrl.data} style={isMobile ? { display: 'block' } : {}}>
								<Button
									icon={<CloseCircleOutlined />}
									size="large"
									disabled={loadingButton}
									style={{ borderRadius: 10, ...(isMobile ? { width: '100%' } : {}) }}
								>
									Batal
								</Button>
							</Link>
							<Button
								type="primary"
								htmlType="submit"
								icon={<SaveOutlined />}
								size="large"
								loading={loadingButton}
								disabled={!persenOk}
								style={{
									borderRadius: 10,
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									border: 'none',
									fontWeight: 600,
									...(isMobile ? { width: '100%' } : {}),
								}}
							>
								{isEdit ? 'Simpan Perubahan' : 'Tambah Target'}
							</Button>
						</div>
					</Card>
				</Form>
			</div>
		);
	}
}

const mapStateToProps = state => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(FormTargetPendapatan);
